<template>
  <div>
    <b-modal
      :title="title"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
      @shown="checkRemind"
    >
      <tables-page
        :tableData="data"
        :tableFields="tableFields"
      >
        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>

        <template #cell(payment_at)="row">
          {{ convertRocDate(row.item.payment_at, false) }}
        </template>

        <template #cell(is_dead)="row">
          {{ row.item.is_dead ? '是' : '否' }}
        </template>

        <template #cell(remark)="row">
         <span :class="{'text-danger': row.item.status !== 1}">
            {{ getRemarkText(row.item) }}
          </span>
        </template>
      </tables-page>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'BatchRemoveBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: '批次銷帳'
    },
    isAutoBill: { // 是否為批次銷自動扣款帳單
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {
    TablesPage
  },
  data () {
    return {
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "會員編號",
        },
        {
          key: "payment_amount",
          label: "付款金額",
        },
        {
          key: "payment_source",
          label: "付款方式",
        },
        {
          key: "payment_at",
          label: "付款日期",
        },
        {
          key: "is_dead",
          label: "是否已身故",
        },
        {
          key: "remark",
          label: "備註",
        },
      ],
      table_fields_auto: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "pay_auto_name",
          label: "自動扣款姓名",
        },
        {
          key: "pay_auto_ID_number",
          label: "自動扣款身分證",
        },
        {
          key: "pay_bank_account",
          label: "自動扣款郵局帳號",
        },
        {
          key: "payment_amount",
          label: "付款金額",
        },
        {
          key: "payment_source",
          label: "付款方式",
        },
        {
          key: "payment_at",
          label: "付款日期",
        },
        {
          key: "remark",
          label: "備註",
        },
      ],
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    tableFields() {
      return this.isAutoBill ? this.table_fields_auto : this.table_fields;
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  methods: {
    convertRocDate,
     getRemarkText(item) {
      const remarkText = {
        auto: {
          0: '無未繳帳單',
          1: '銷帳成功',
          2: item => `金額不相符, ${item.need_pay}(應付帳款) - ${item.real_pay}(實際付款) = ${item.need_pay - item.real_pay}元`,
          3: '重複銷帳',
          4: '結存不足',
          5: '未申請代繳或用戶號碼錯誤',
        },
        notAuto: {
          0: '無未繳帳單',
          1: '銷帳成功',
          2: item => `金額不相符, ${item.need_pay}(應付帳款) - ${item.real_pay}(實際付款) = ${item.need_pay - item.real_pay}元`,
          3: '重複銷帳',
          4: '身故不可銷帳',
        }
      };

      const selectedRemark = this.isAutoBill ? remarkText.auto : remarkText.notAuto;

      return typeof selectedRemark[item.status] === 'function' ? selectedRemark[item.status](item) : selectedRemark[item.status];
    },
    // checkRemind() {
    //    if (this.data.some(item => item.status !== 1)) {
    //     const text = this.data
    //       .filter(item => item.status !== 1 && item.status !== 3)
    //       .map(item => `${this.isAutoBill ? item.pay_auto_name : item.number} ${this.getRemarkText(item)}`)
    //       .join(', ');

    //     if (text) alert(text);
    //   }
    // }
    checkRemind() {
      const text = this.data
        .filter(item => {
          // 如果不是自動扣款帳單，且該筆資料已身故，則強制顯示
          if (!this.isAutoBill && item.is_dead) return true;
          // 其他情況下，排除成功(1)與重複(3)的紀錄
          return item.status !== 1 && item.status !== 3;
        })
        .map(item => {
          // 顯示名稱（根據是否為自動扣款帳單）
          const name = this.isAutoBill ? item.pay_auto_name : item.number;

          // 若是非自動扣款帳單且有身故，顯示「(已身故)」
          const deadText = !this.isAutoBill && item.is_dead ? "(已身故)" : "";

          // 顯示最終提示內容
          return `${name}${deadText} ${this.getRemarkText(item)}`;
        })
        .join(', ');

      if (text) alert(text);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BatchRemoveBillModal.vue